import { useState, useCallback, useRef } from 'react';
import type { Instance, Effect } from '../types';

export const useBoardState = () => {
  const [instances, setInstances] = useState<Instance[]>([]);
  const [effects, setEffects] = useState<Effect[]>([]);
  const idCounter = useRef(1);

  const addInstance = useCallback((elementKey: string, x: number, y: number) => {
    setInstances(prev => [
      ...prev,
      { id: idCounter.current++, elementKey, x, y }
    ]);
  }, []);

  const removeInstanceById = useCallback((id: number) => {
    setInstances(prev => prev.filter(i => i.id !== id));
  }, []);

  const updateInstancePos = useCallback((id: number, x: number, y: number) => {
    setInstances(prev => prev.map(i => (i.id === id ? { ...i, x, y } : i)));
  }, []);

  const resetBoard = useCallback(() => setInstances([]), []);

  return {
    instances,
    setInstances,
    effects,
    setEffects,
    addInstance,
    removeInstanceById,
    updateInstancePos,
    resetBoard,
    idCounter,
  };
};
